/**
 * FeaturedCourse — Sidebar course spotlight card.
 *
 * Terminal/Blueprint aesthetic. Sits below the newsletter widget
 * in the post sidebar.
 *
 * Classes: fc-* namespace
 * Site: veil-framework
 */
import React from "react";
import RecommendedLink from "./RecommendedLink";

export default function FeaturedCourse() {
  const href = "/veil-recommends/infosec-fundamentals";

  return (
    <aside className="fc-wrap" aria-label="Recommended course">
      {/* Terminal chrome */}
      <div className="fc-header">
        <span className="fc-dot fc-dot-r" aria-hidden="true" />
        <span className="fc-dot fc-dot-a" aria-hidden="true" />
        <span className="fc-dot fc-dot-g" aria-hidden="true" />
        <span className="fc-header-label">course_spotlight.sh</span>
      </div>

      {/* Course image */}
      <RecommendedLink href={href} className="fc-image-link" aria-label="View Information Security Fundamentals course">
        <img
          src="/img/hero/infosec-fundamentals.webp"
          alt="Information Security Fundamentals course cover"
          className="fc-image"
          loading="lazy"
          width="300"
          height="169"
        />
      </RecommendedLink>

      {/* Course body */}
      <div className="fc-body">
        <div className="fc-tag">Recommended Course</div>

        <h3 className="fc-title">
          <RecommendedLink href={href} className="fc-title-link">
            Information Security Fundamentals
          </RecommendedLink>
        </h3>

        <p className="fc-desc">
          Build a solid foundation in cybersecurity. Covers network fundamentals,
          common attack vectors, defensive controls, and the mindset needed for
          security research.
        </p>

        <ul className="fc-features">
          <li className="fc-feature">
            <span className="fc-feature-icon" aria-hidden="true">▸</span>
            Beginner-friendly — no prior experience needed
          </li>
          <li className="fc-feature">
            <span className="fc-feature-icon" aria-hidden="true">▸</span>
            Network attacks &amp; defences
          </li>
          <li className="fc-feature">
            <span className="fc-feature-icon" aria-hidden="true">▸</span>
            Real-world security concepts
          </li>
        </ul>

        <RecommendedLink href={href} className="fc-cta">
          View Course
          <span className="fc-cta-arrow" aria-hidden="true"> →</span>
        </RecommendedLink>

        <p className="fc-disclosure">
          We may earn a commission if you enrol via our link, at no extra cost to you.
        </p>
      </div>
    </aside>
  );
}
